import { useMemo } from "react";
import { useSelector } from "react-redux";

import { ProjectAction } from "../types";
import useGetProjectBriefData from "src/app/project/hooks/useGetProjectBriefData";
import { RootState } from "src/redux/reducers";

export default function useGetAIWizardProjectSettings(
  projectAction: ProjectAction,
) {
  const { newProjectBriefData } = useSelector(
    (state: RootState) => state.mainReducer,
  );
  const { briefCampaignSuggestions } = useGetProjectBriefData();

  const suggestions = useMemo(
    () =>
      projectAction === "activate"
        ? briefCampaignSuggestions
        : newProjectBriefData?.campaignSuggestions ?? null,
    [
      projectAction,
      briefCampaignSuggestions,
      newProjectBriefData?.campaignSuggestions,
    ],
  );

  return {
    projectName: suggestions?.campaign_name ?? "",
    avatar: suggestions?.brand_avatar_url ?? "",
    templates: suggestions?.templates ?? [],
    currencyCode: suggestions?.currency_code ?? "",
  };
}
